/**
 * Utility to handle browser-level file downloads and previews from Blobs.
 */
export const fileUtils = {
  /**
   * Opens a Blob in a new browser tab.
   * Handles the URL lifecycle (creation and revocation).
   *
   * @param blob The blob content to display
   * @param revokeDelay Ms to wait before revoking the URL (default 1000)
   */
  openInNewTab: (blob: Blob, revokeDelay = 1000) => {
    const url = window.URL.createObjectURL(blob);
    const win = window.open(url, '_blank');

    if (win) {
      win.focus();
    }

    // Revoke the URL after a delay to allow the browser to process it
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, revokeDelay);
  },

  /**
   * Triggers a browser download for a Blob.
   *
   * @param blob The blob content to download
   * @param fileName The name of the file to be saved
   */
  downloadFile: (blob: Blob, fileName: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  }
};
